import { Component, NgZone, OnInit, inject } from '@angular/core';
import {
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../guards/service/auth.service';
import { FreelancerDataService } from '../../../services/freelancer-data.service';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DomainService } from '../../domain/domain.service';

@Component({
  selector: 'app-forgot-password',
  imports: [CommonModule, ReactiveFormsModule, RouterModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css'
})
export class ForgotPasswordComponent implements OnInit {

  forgotPasswordForm!: UntypedFormGroup;
  constructor(
    private fb: UntypedFormBuilder, private dataService: FreelancerDataService,
    private router: Router, private toastrService: ToastrService,
    private authGuardService:  AuthService,
    public domainService: DomainService,
  ) { }

  ngOnInit(): void {
    this.initializeForgotPasswordForm();
    // if (this.authGuardService.isLoggedIn()) {
    //   this.router.navigate(['/profile']);
    // }
  }

  initializeForgotPasswordForm(): void {
    this.forgotPasswordForm = this.fb.group({
      email: new UntypedFormControl('', [Validators.required, Validators.email]),
    });
  }

  forgotPasswordSubmit(): void { }

sendOTP(): void {
  const email = (this.forgotPasswordForm.value.email || '').trim();
  if (!email) return;

  this.dataService.sendOTP({ email }).subscribe(
    (res: { data?: string }) => {
      this.toastrService.success(res.data);

      const encoded = encodeURIComponent(email);

      if (this.domainService.isCommunityDomain()) {
        const slug = localStorage.getItem('slug');
        const communityId = localStorage.getItem('communityId');

        
        if (slug && communityId) {
          this.router.navigate(['/', slug, communityId, 'reset-password', encoded]);
        } else {
          
          this.router.navigate(['/login']);
        }
      } else {
       
        this.router.navigate(['/reset-password', encoded]);
      }
    },
    (err: { error: { error: { description?: string } } }) => {
      this.toastrService.error(err?.error?.error?.description || 'Failed to send OTP');
    }
  );
}

  backTosignIn(){
    const slug = localStorage.getItem('slug');
    const communityId = localStorage.getItem('communityId');
  
    if (this.domainService.isCommunityDomain() && slug && communityId) {
      this.router.navigate([`/${slug}/${communityId}/login`]);
    } else {
      this.router.navigate(['/login']);
    }
  }
}

